import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Link from "next/link";
import { useRouter } from "next/router";
import { Image } from 'react-bootstrap';

export default function Consulting()
{
    const router = useRouter();
    return (
        <>
            <section className="hero-reseller consulting-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div className="hero-copy d-inline-block">
                        <h1 className="publicBannerHeading">Consulting & Professional Services</h1>
                    </div>
                </div>
                  <Link
                    className="btn btn-info text-white mt-3 float-end"
                    href="/industry_questions"
                >
                    VIEW EXPERT QUESTIONS
                </Link>
            </section>

            <section className="py-5 bg-white">
                <div className="container">
                    <div className="mb-4">
                            <button
                            onClick={() => router.back()}
                            className="button btn-purple me-3 text-uppercase border-0 p-2 px-3"
                        >
                            Back
                        </button>
                        <Link className="button btn-purple me-3" href="/contact">BOOK A DEMO</Link>
                        <Link className="button btn-purple me-3" href="/register">REGISTER</Link>
                        <Link className="button btn-purple me-3" href="/pricing">PRICING</Link>
                        <Link className="button btn-purple me-3" href="/register">TRY A FREE POLL</Link>

                        <Link className="button btn-purple" href="/faq">FAQ</Link>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold secondaryColor mb-4 publicTextNew">
                                Sharper insight. Stronger alignment.<br />Smarter outcomes.
                            </h2>
                            <p className="text-muted mb-3">
                                Every conversation with a client or stakeholder holds valuable data — if you can capture it in the moment. Instant Polls gives <b> management consultants</b>, advisors, and professional service firms the ability to gauge <b>stakeholder sentiment</b>, test ideas, and validate <b>strategic decisions</b> instantly.                            </p>
                            <p className="text-muted mb-3">
                                From high-stakes <b>client workshops</b> to <b>strategic planning sessions</b>, our <b>consulting software</b> helps you uncover what people really think. Move from assumption to action with clarity and confidence, ensuring your <b>event or conference sessions</b> provide the <b> real-time insights </b> needed to lead.                            </p>
                            <p className="text-muted mb-3">
                                Because in professional services and  <b>enterprise event management</b>, timing isn’t a luxury — it’s a competitive advantage.                            </p>
                        </div>
                        <div className="col-lg-6 text-center">
                            <Image src="/industry/consulting-polling-tool.png" alt="consulting firm using instant polling software" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-blue">
                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Challenge</h5>
                                    <p className="card-text text-muted">
                                        In <b>management consulting</b> and advisory work, critical decisions hinge on<b> stakeholder alignment </b> and perception. However, traditional feedback methods are slow, formal, and disconnected from the pace of high-level discussion. By the time <b>post-meeting surveys</b> are compiled, the momentum—and the strategic insight—has passed.                                    </p>
                                    <p className="card-text text-muted">
                                        Advisors need a faster, more dynamic way to read the room during <b>client workshops</b> and <b>corporate events</b>. To lead effectively, you must test buy-in and guide decisions with <b>real-time evidence</b> rather than guesswork. Without <b>live audience interaction</b>, consultants risk losing the &#34;aha&#34; moment that drives <b>change management</b> success.                                        </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Solution</h5>
                                    <p className="card-text text-muted">
                                        Fully <b>white-labeled</b>, our platform reflects your firm’s <b>brand identity</b> and professionalism, enhancing your credibility during every <b>client engagement</b>. With no subscriptions or long-term contracts, Instant Polls fits seamlessly into <b>strategic planning sessions</b>, client forums, and advisory boards.                                    </p>
                                    <p className="card-text text-muted">
                                        Whether you are hosting an <b>executive workshop</b> or a <b>corporate conference</b>, the platform provides <b>instant insights</b> you can act on immediately. It’s the difference between asking a question and understanding the answer—exactly when it matters most for your <b>business consulting</b> strategy.                                        </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Result</h5>
                                    <p className="card-text text-muted">
                                        Instant Polls helps <b>management consultants</b> and <b>professional service firms</b> turn meetings into moments of clarity. It improves <b>client confidence</b>, accelerates <b>strategic decision making</b>, and creates visible <b>stakeholder alignment</b> across complex teams. </p>
                                    <p className="card-text text-muted">The result is a <b>consulting experience</b> that feels smarter, faster, and more human—one that transforms complex discussion into clear direction. Because when <b> business insight </b> moves at the speed of the conversation, every <b>client engagement</b> delivers more value.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="features py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4 highlightedColor">How Instant Polls Works</h2>
                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Real-Time Dashboards</div>
                                    <p className="rfeature-text">Result stream in live, no refresh required.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">AI-Powered Sentiment</div>
                                    <p className="rfeature-text">Understand tone and context, not just raw numbers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Segmentation</div>
                                    <p className="rfeature-text">Break results down by department, region, or demographics.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Seamless Integration</div>
                                    <p className="rfeature-text">Works with Microsoft Teams, Slack, CRMs, and more.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/cyber-security-icon.png" alt="data security and privacy icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Enterprise-Grade Security</div>
                                    <p className="rfeature-text">Anonymous by default, encrypted end-to-end</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/outline.png" alt="reporting and insights icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">White-Label Branding</div>
                                    <p className="rfeature-text">Brand every poll as your own.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 publicNewBgvColor">
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="lead-section-consulting d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 py-5">
                            <h3 className="fw-bold mb-3 publicPageNewTextColor">Transform the way <br />you capture client insight.</h3>
                            <p className="text-muted mb-3 text-dark">
                                Discover how Instant Polls helps you transform <b>audience feedback</b> into active learning, spark <b> participation </b>, and make every session more impactful. Whether you are facilitating a <b> keynote </b>, a panel, or a<b> corporate workshop</b>, our platform gives you the <b>real-time clarity</b> and connection that make your message stick.                            </p>
                            <Link href="/contact" className="btn btn-purple rounded-pill px-4 py-2" >BOOK A DEMO</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

Consulting.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;
